import React from 'react';
import Modal from 'react-responsive-modal';
import { Link } from 'react-router-dom';
import Template from '../../img/template.svg';
import Empty from '../../img/empty.svg';
import { createBoard } from '../../services/api/api';

const createNewBoard = async () => {
  const newBoardId = await createBoard();
  window.location.href = `/board/${newBoardId}`;
};

const CreateBoardModal = ({ isOpen, onClose }) => (
  <Modal
    open={isOpen}
    onClose={onClose}
    closeIconSize={32}
    classNames={{ modal: 'modal-bg', closeIcon: 'close-icon' }}
    center
  >
    <div className="p-2">
      <div className="w-100 m-b-2">
        <h1>How do You want to start?</h1>
      </div>
      <div className="w-100 d-flex">
        <div className="w-50 box">
          <Link to={'/templates'}>
            <img src={Template} alt="template" className="w-100 box-img" />
            <h2>Create from Circly Template</h2>
          </Link>
        </div>
        <div className="w-50 box" onClick={createNewBoard}>
          <img src={Empty} alt="from scratch" className="w-100 box-img" />
          <h2>Start from scratch</h2>
        </div>
      </div>
    </div>
  </Modal>
);

export default CreateBoardModal;
